import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { t } = useTranslation('common');

  const navLinks = [
    { label: t('nav.home'), href: '/' },
    { label: t('nav.artists'), href: '/artistas' },
    { label: t('nav.register'), href: '/registro' },
    { label: t('nav.about'), href: '/sobre-nosotros' },
  ];

  return (
    <nav
      className="fixed top-0 left-0 right-0 z-50 transition-all duration-500 bg-white/80 backdrop-blur-md shadow-sm"
    >
      <div className="w-full px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 md:w-10 md:h-10 flex items-center justify-center bg-amber-600 rounded-lg">
              <i className="ri-music-fill text-white text-sm md:text-base"></i>
            </div>
            <span className="text-lg md:text-xl font-bold tracking-tight text-gray-900 transition-colors">
              Piano Music Entertainment
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8 lg:gap-10">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className="text-sm font-medium text-gray-700 transition-colors hover:text-amber-600"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/artistas"
              className="text-sm font-medium px-5 py-2.5 bg-amber-600 text-white rounded-full hover:bg-amber-700 transition-colors whitespace-nowrap"
            >
              {t('nav.searchTalent')}
            </Link>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-lg text-gray-900"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
          <div className="px-6 py-4 space-y-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                onClick={() => setMobileMenuOpen(false)}
                className="block py-3 text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors"
              >
                {link.label}
              </Link>
            ))}
            <Link
              to="/artistas"
              onClick={() => setMobileMenuOpen(false)}
              className="block mt-2 text-sm font-medium px-5 py-2.5 bg-amber-600 text-white rounded-full text-center whitespace-nowrap"
            >
              {t('nav.searchTalent')}
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}